export const VIP_LEVELS = [
  "NEW",
  "NORMAL",
  "COPPER",
  "SILVER",
  "GOLD",
  "PLATINUM",
  "EMERALD",
  "SAPPHIRE",
  "DIAMOND",
];

export const VIP_ORDER = VIP_LEVELS.reduce((acc, key, index) => {
  acc[key] = index;
  return acc;
}, {});
